module.exports = __webpack_public_path__ + "media/images/inbox/tab-arrow-475f81c98d3e62467b8985b1f2f1c7cb.svg";